var collapsible_list_pair_rtlignore_default = {
  "container": "_049QV",
  "title": "_2hHtx",
  "viewerContainer": "iwh9S",
  "titleContainer": "PRNOq",
  "content": "GudMI",
  "expandIcon": "NdN91",
  "dndIcon": "nDTnj",
  "RTL": "-Mqzc",
  "LTR": "kYGDT",
  "itemContainer": "pEJ7j",
  "itemContainerViewer": "oZkLJ",
  "mouseDown": "izRUa",
  "innerEditor": "va0jh",
  "item": "-ZchC",
  "floatingAddPluginMenuWrapper": "PhxeO"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
